import { Component, Inject, OnInit, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-sizing-progress-dialog',
  templateUrl: './sizing-progress-dialog.component.html',
  styleUrl: './sizing-progress-dialog.component.scss',
  standalone: false
})
export class SizingProgressDialogComponent implements OnInit{

  total = 0;
  processed = 0;
  currentComponent = '';
  title = '';
  progress = 0;
  showCount : boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      title: any; processed?: number; total?: number; currentComponent?: string; progress?: number,showCount: boolean
},
    public matdialogRef: MatDialogRef<SizingProgressDialogComponent>
  ) {}

  ngOnInit(): void {
    this.title = this.data?.title;
    this.processed = this.data?.processed || 0;
    this.total = this.data?.total || 0;
    this.currentComponent = this.data?.currentComponent || '';
    this.progress = this.data?.progress;
    this.showCount = this.data.showCount;
  }
}
